import { BookUser, UserPlus } from "lucide-react";
import { MailActivityJournalButton } from "./MailActivityJournalButton";
import { MailGuideModal } from "./MailGuideModal";
import { MailHeaderIconButton } from "./MailHeaderIconButton";
import { MailPwaInstallButton } from "./MailPwaInstallButton";
import { MailShellOverflowMenu } from "./MailShellOverflowMenu";
import { MailTooltip } from "@/features/shared/MailTooltip";

type Props = {
  onAddAccount?: () => void;
  onOpenAddressBook?: () => void;
};

export function MailShellHeaderActions({ onAddAccount, onOpenAddressBook }: Props) {
  return (
    <div className="flex shrink-0 items-center gap-0.5">
      <MailActivityJournalButton />
      {onAddAccount ? (
        <MailTooltip label="Ajouter un compte" side="bottom" compact>
          <MailHeaderIconButton label="Ajouter un compte" onClick={onAddAccount}>
            <UserPlus className="h-4 w-4" strokeWidth={2} />
          </MailHeaderIconButton>
        </MailTooltip>
      ) : null}
      {onOpenAddressBook ? (
        <MailTooltip label="Carnet d’adresses" side="bottom" compact>
          <MailHeaderIconButton label="Carnet d’adresses" onClick={onOpenAddressBook}>
            <BookUser className="h-4 w-4" strokeWidth={2} />
          </MailHeaderIconButton>
        </MailTooltip>
      ) : null}
      <MailGuideModal />
      <MailPwaInstallButton />
      <MailShellOverflowMenu />
    </div>
  );
}
